import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeElafron';
const args = {};

export class ModeElafron extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
